export default __webpack_public_path__ + "static/media/Malvie.abd4a43e.woff";